import React from 'react';
import { useSelector } from 'react-redux';
import { selectActiveRole } from '../../slices/userRoleSlice';

import { AuthStdFooter } from "../../utils/auth-std-footer";
const DebugUserRole = () => {
  const activeRole = useSelector(selectActiveRole);
  const userProfile = useSelector(state => state.user.profile);
  const userRole = useSelector(state => state.user.userRole);
  const wholeUserState = useSelector(state => state.user);

  return (
    <div style={{ marginBottom: "70px", padding: '20px', fontFamily: 'monospace' }}>
      <h2>Debug User Role Information</h2>

      <h3>Active Role:</h3>
      <pre>{JSON.stringify(activeRole, null, 2)}</pre>

      <h3>User Profile:</h3>
      <pre>{JSON.stringify(userProfile, null, 2)}</pre>

      <h3>User Role State:</h3>
      <pre>{JSON.stringify(userRole, null, 2)}</pre>

      <h3>Whole User State:</h3>
      <pre>{JSON.stringify(wholeUserState, null, 2)}</pre>
      {AuthStdFooter()}
    </div>
  );
};

export default DebugUserRole;
